import { gql } from '@apollo/client'

export default gql`
    mutation SaveCaption ($taskId: ID!,$caption: [TranscriptInput]) {
      saveCaption(taskId: $taskId, caption: $caption)
    }
`